module.exports = __webpack_public_path__ + "img/down-arrow.6349e1fa.svg";